import { Navbar, Nav, NavDropdown, Image } from 'react-bootstrap';
import { Container } from '@material-ui/core';

import history from '../../history';

import Avatar from './Avatar';

import logo from '../../assets/logo.png';

import './styles.css';


export default function NavBar({ children }) {
  return (
    <div>
      <Navbar
        collapseOnSelect
        bg="light"
        expand="lg"
      >
        <Navbar.Brand>
          {' '}
          <Image
            style={{ cursor: 'pointer' }}
            src={logo}
            width="120"
            height="50"
            onClick={() => {
              history.push('/Main')
            }}
          />
        </Navbar.Brand>
        <Container maxWidth="xl">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="/Chamados">Chamados</Nav.Link>
              <Nav.Link href="/Mon">Monitoramento</Nav.Link>

              <NavDropdown title="Backups" id="basic-nav-dropdown">
                <NavDropdown.Item href="/reportsemanal/all">
                  Backups
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/reportsemanal/empresas">
                  Backups (Por empresa)
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Empresas" id="basic-nav-dropdown">
                <NavDropdown.Item href="/Gestao/empresas">
                  Listar empresas
                </NavDropdown.Item>
                <NavDropdown.Divider />

                <NavDropdown.Item href="/cad/empresas">
                  Gestão de empresas
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link href="/Users">
                Usuários
              </Nav.Link>

              <Nav.Link href="/Gestao">
                Gestão
              </Nav.Link>
            </Nav>
            <div className="avatar">
              <Avatar />
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <main>
        <Container maxWidth="xl">
          {children}
        </Container>
      </main>
    </div>
  );
}
